<template>
  <div id="Tab3">
    <!-- Intereses -->
    <div class="expectations-wrap">
      <SectionTitle :has-line="false" content="II. Intereses" />
      <div class="dropdown-divider mt-0 pb-2 ml-3" />
      <div class="expectation-question-item expectation-question-item-1">
        <div class="eq-field">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
            immediate
            name=" "
          >
            <CustomTextArea
              id="goals"
              v-model="AcademicInfo.interests"
              label="Exponga los intereses que el estudiante manifiesta:"
              :maxlength="300"
              :classes="['eq-field']"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
    <!-- Información Educativa -->
    <SectionTitle :has-line="false" content="III. Información Educativa" />
    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="form-group mb-4">
      <span>Aprovechamiento Académico:</span>

      <div class="d-flex mt-3 mb-2">
        <div class="w-auto">
          <div class="custom-control custom-radio">
            <input
              id="radioyes"
              v-model="AcademicInfo.academicAchievementFlag"
              type="radio"
              class="custom-control-input"
              :value="true"
              name="yes"
            />
            <label
              class="custom-control-label"
              style="font-weight: normal;"
              for="radioyes"
            >
              Satisfactorio
            </label>
          </div>
        </div>
        <div class="w-auto ml-5">
          <div class="custom-control custom-radio">
            <input
              id="radiono"
              v-model="AcademicInfo.academicAchievementFlag"
              type="radio"
              class="custom-control-input"
              name="radiono"
              :value="false"
            />
            <label
              class="custom-control-label"
              style="font-weight: normal;"
              for="radiono"
            >
              No satisfactorio
            </label>
          </div>
        </div>
      </div>
      <Error
        variant="no-border p-0"
        :message="validateRadiobuttons(AcademicInfo.academicAchievementFlag)"
      />
    </div>
    <!-- Grados Repetidos -->
    <ValidationObserver ref="gradesValidator">
      <div class="panel-simple mt-4 thead-property">
        <div class="header">
          <div class="col-md-10">
            <span class="bold">Grados Repetidos (si aplica)</span>
          </div>
        </div>
      </div>
      <div
        v-for="(repeatedGrade, index) in AcademicInfo.peiAtrepeatedDegrees"
        :key="index"
      >
        <template v-if="repeatedGrade.id == 0">
          <div class="panel-simple">
            <div class="">
              <SectionTitle
                icon="fas fa-plus"
                content="Añadir Grados Repetidos"
                container-class="mt-4 mb-2 mx-3"
              />
            </div>
          </div>
          <div
            class="col-12 d-flex panel-row pb-4 bg-gray mb-4 shadow-top px-35 pt-4 m-0 justify-content-between align-items-start"
          >
            <div class="col-4">
              <ValidationProvider
                v-slot="{ errors }"
                name="Grado"
                class="w-25 text-left"
                rules="required"
              >
                <CustomDropDown
                  v-model="repeatedGrade.grade"
                  label="Grado:"
                  placeholder="Seleccionar"
                  required
                  fieldkey="id"
                  fieldname="gradeDescSpanish"
                  :options="AcademicInfoOptions.schoolGrades"
                  :error="gradeDDError"
                  :custom-error-msg="gradeDDError"
                />
              </ValidationProvider>
            </div>
            <div class="col-3">
              <ValidationProvider
                v-slot="{ errors }"
                class="text-left"
                name="Veces"
                rules="required"
              >
                <CustomInput
                  v-model="repeatedGrade.quantity"
                  label="Cuantas veces:"
                  required
                  type="number"
                  :min="1"
                  :error="gradeNumberError"
                  :custom-error-msg="gradeNumberError"
                />
              </ValidationProvider>
            </div>
            <div class="col-3 buttons-container text-right">
              <ActionButton
                class="mr-2"
                variant="outline-danger"
                i="fas fa-times-circle"
                @click="cancelRepeatedGrade(index)"
              >
                Cancelar
              </ActionButton>
              <ActionButton
                variant="success"
                i="fas fa-file-plus"
                @click="addFilledGrade(repeatedGrade)"
              >
                Añadir
              </ActionButton>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="col-12 d-flex panel-row bg-gray  px-35 pt-1 pb-1 m-0 justify-content-between items-align-center"
          >
            <div class="col-4 selectbox text-left">
              <div class="form-group">
                <label for="sel1">
                  Grado:
                  <span style="font-weight: normal;">
                    {{
                      AcademicInfoOptions.schoolGrades.find(
                        (x) => x.id == repeatedGrade.gradeId
                      ).gradeDescSpanish
                    }}
                  </span>
                </label>
              </div>
            </div>
            <div class="col-3 divbox text-left">
              <div class="form-group">
                <label for="sel1">
                  Cuantas veces:
                  <span style="font-weight: normal;">
                    {{ repeatedGrade.quantity }}
                  </span>
                </label>
              </div>
            </div>
            <div class="col-3 text-right ">
              <ActionButton
                variant="outline-danger"
                i="fas fa-times-circle"
                @click="deleteRepeatedGrade(index, true)"
              >
                Eliminar
              </ActionButton>
            </div>
          </div>
        </template>
      </div>

      <div v-if="showAddRepeatedGradeBtn" class="d-flex justify-content-center">
        <BoxIconButton
          class="w-50 my-4"
          title="Presione aquí para añadir Grados Repetidos"
          icon="fas fa-file-plus"
          @click="addEmptyGrade"
        />
      </div>
    </ValidationObserver>

    <div class="expectations-wrap mt-4">
      <div class="expectation-question-item expectation-question-item-1">
        <!--        eq stands for "expectation question" -->

        <div class="eq-field">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
            immediate
            name=" "
          >
            <CustomTextArea
              id="latestSchoolReportComment"
              v-model="AcademicInfo.latestSchoolReportComment"
              label="Especificar las notas en el último reporte escolar (si aplica):"
              :maxlength="300"
              :classes="['eq-field']"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div class="expectations-wrap">
      <div class="expectation-question-item expectation-question-item-1">
        <!--        eq stands for "expectation question" -->
        <div class="eq-field">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="`${this.ValidationTriggered.validation ? 'required' : ''}`"
            immediate
            name=" "
          >
            <CustomTextArea
              v-model="AcademicInfo.academicAchievementComment"
              label="Comentarios adicionales sobre aprovechamiento académico:"
              :maxlength="300"
              :classes="['eq-field']"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div class="form-group mb-4">
      <div class="d-flex mt-3 mb-2">
        <span class="d-flex main-blockquote mr-2">Nivel de actividad:</span>
        <div class="w-auto">
          <div class="custom-control custom-radio">
            <input
              id="adecuado"
              v-model="AcademicInfo.activityLevel"
              type="radio"
              class="custom-control-input"
              name="noadecuado"
              :value="1"
            />
            <label
              class="custom-control-label"
              style="font-weight: normal;"
              for="adecuado"
            >
              Adecuado
            </label>
          </div>
        </div>
        <div class="w-auto ml-3">
          <div class="custom-control custom-radio">
            <input
              id="variable"
              v-model="AcademicInfo.activityLevel"
              type="radio"
              class="custom-control-input"
              name="noadecuado"
              :value="2"
            />
            <label
              class="custom-control-label"
              style="font-weight: normal;"
              for="variable"
            >
              Variable
            </label>
          </div>
        </div>
        <div class="w-auto ml-3">
          <div class="custom-control custom-radio">
            <input
              id="noadecuado"
              v-model="AcademicInfo.activityLevel"
              type="radio"
              class="custom-control-input"
              name="noadecuado"
              :value="3"
            />
            <label
              class="custom-control-label"
              style="font-weight: normal;"
              for="noadecuado"
            >
              Difícil de Mantener
            </label>
          </div>
        </div>
      </div>
      <Error
        variant="no-border p-0"
        :message="validateRadiobuttons(AcademicInfo.activityLevel)"
      />
    </div>
    <div
      v-for="question in AcademicInfoOptions.questionaireQuestions"
      :key="question.id"
      class="form-group mb-4"
    >
      <div v-for="item in question.questions" :key="item.id">
        <span>{{ item.text }}:</span>
        <Error
          variant="no-border p-0"
          :message="
            validateQuestionMark(item) ? '' : 'Debe seleccionar al menos 1'
          "
        />
        <div class="row" style="padding-left: 30px;">
          <div
            v-for="answer in item.answers"
            :key="answer.id"
            class="custom-control custom-checkbox col-4"
          >
            <input
              :id="answer.id"
              v-model="answer.isSelected"
              type="checkbox"
              :class="isValidQuestion(item)"
              @click="
                answer.validationName != null
                  ? checkboxGroupValidation(
                      item.answers,
                      answer.validationName,
                      answer.id
                    )
                  : null
              "
            />

            <label
              class="custom-control-label"
              style="font-weight: normal;"
              :for="answer.id"
            >
              {{ answer.text }}
            </label>
          </div>
        </div>
        <div v-if="questionHasOthers(item)" class="expectations-wrap my-4">
          <div class="expectation-question-item expectation-question-item-1">
            <div class="eq-field">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                immediate
                name=" "
              >
                <CustomTextArea
                  v-model="getOthers(item.answers).comment"
                  :disabled="atCompletedFlag"
                  :maxlength="300"
                  :classes="['eq-field']"
                  :error="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- fin Contenido -->
</template>

<style scoped src="@/assets/css/pei/parte-k.css"></style>

<script>
import '@/assets/css/atservices/AcademicInfo.css';
import alert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.
import { SectionTitle } from '@/components/pei/shared';
import CustomTextArea from '../../common/CustomTextArea';
import CustomInput from '@/components/common/CustomInput';
import loading from '@/mixin/loading.mixin';
import atService from '@/services/pei/at';
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import ActionButton from '../../common/ActionButton';
import Error from '@/components/common/Error.vue';
import CustomDropDown from '@/components/common/CustomDropDown';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapMutations } from 'vuex';

export default {
  name: 'Tab3',
  mixins: [loading, alert],
  components: {
    ActionButton,
    CustomTextArea,
    SectionTitle,
    BoxIconButton,
    Error,
    ValidationProvider,
    ValidationObserver,
    CustomDropDown,
    CustomInput,
  },
  data() {
    return {
      showAddRepeatedGradeBtn: true,
      gradeDDError: null,
      gradeNumberError: null,
      AcademicInfo: {},
      AcademicInfoOptions: {},
      repeatedGradesId: 0,
      resources: [],
      ValidationTriggered: store.getters.getatValidationTriggered,
    };
  },
  methods: {
    ...mapMutations(['setATSaveBtnDisable']),
    cancelRepeatedGrade(index) {
      this.gradeDDError = null;
      this.gradeNumberError = null;
      this.deleteRepeatedGrade(index, false);
      this.showAddRepeatedGradeBtn = true;
    },
    async getAcademicInfoOptions() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/atservice/getacademicinfooptions')
          .then((res) => {
            self.AcademicInfoOptions = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            this.response = err;
          });
      });
      return promise;
    },
    async getAcademicInfo(atServiceId) {
      let promise = new Promise((resolve) => {
        if (atServiceId == null) {
          atServiceId = 0;
        }

        this.$ApiGet(
          '/api/atservice/getacademicinfo?peiAtServiceId=' + atServiceId
        )
          .then((res) => {
            this.AcademicInfo = res.data;
            resolve(this.AcademicInfo);
          })
          .catch((err) => {
            this.response = err;
          });
      });

      return promise;
    },
    toggleClass(answer) {
      if (
        this.AcademicInfo.peiAtserviceEducativeQualities.find(
          (x) => x.questionnaireAnswerId == answer.id
        ) != null
      )
        answer.isSelected = true;
    },
    questionHasOthers(question) {
      let answer = question.answers.find((x) => x.text == 'Otros');

      if (answer != null) {
        return answer.isSelected;
      } else {
        return false;
      }
    },
    getOthers(answers) {
      return answers.find((x) => x.text == 'Otros');
    },
    async save() {
      let Qualities = [];

      let atServiceId = this.atServiceId;

      if (this.atServiceId === 0) {
        const createdAtServiceId = await atService.createAtService(
          store.getters.SelectedPei
        );

        if (createdAtServiceId > 0) {
          store.dispatch('setSelectedAt', createdAtServiceId);
          atServiceId = createdAtServiceId;

          this.AcademicInfo.peiAtrepeatedDegrees.forEach((element) => {
            element.peiAtServiceId = atServiceId;
          });

          this.AcademicInfo.peiAtServiceId = atServiceId;
        }
      }

      this.AcademicInfoOptions.questionaireQuestions.forEach((section) => {
        section.questions.forEach((question) => {
          question.answers.forEach((answer) => {
            if (answer.isSelected) {
              Qualities.push({
                comment: answer.comment,
                id: 0,
                peiAtServiceId: this.AcademicInfo.peiAtServiceId,
                questionnaireAnswerId: answer.id,
                questionnaireQuestionId: question.id,
              });
            }
          });
        });
      });

      this.AcademicInfo.peiAtserviceEducativeQualities = Qualities;

      this.$ApiPost(`/api/atservice/saveacademicinfo`, this.AcademicInfo)
        .then(
          function() {
            this.ShowToast(
              this.resources['R03200110'],
              this.resources['R03200109'],
              'success'
            );
          }.bind(this)
        )
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    fillAcademicInfo() {
      let self = this;
      self.AcademicInfoOptions.questionaireQuestions.forEach((section) => {
        section.questions.forEach((question) => {
          question.answers.forEach((answer) => {
            let AcademicInfoObject = self.AcademicInfo.peiAtserviceEducativeQualities.find(
              (x) => x.questionnaireAnswerId == answer.id
            );

            if (AcademicInfoObject != null) {
              answer.isSelected = true;
              answer.comment = AcademicInfoObject.comment;
            }
          });
        });
      });
    },
    addEmptyGrade() {
      this.showAddRepeatedGradeBtn = false;
      this.AcademicInfo.peiAtrepeatedDegrees.push({
        id: 0,
        gradeId: 0,
        grade: null,
        peiAtServiceId: this.atServiceId,
        quantity: 1,
      });
    },
    async deleteRepeatedGrade(index, showConfirm) {
      if (showConfirm) {
        const response = await this.ShowCancelModal(
          this.resources.R900001,
          this.resources['191210'],
          this.resources.R90007,
          this.resources.R90008
        );
        if (response) {
          this.$delete(this.AcademicInfo.peiAtrepeatedDegrees, index);
        }
      } else {
        this.$delete(this.AcademicInfo.peiAtrepeatedDegrees, index);
      }
    },

    addFilledGrade(repeatedGrade) {
      let self = this;
      self.$refs.gradesValidator.validate().then(function(isValid) {
        if (repeatedGrade.grade != null) {
          const existingGrade = self.AcademicInfo.peiAtrepeatedDegrees.find(
            (x) => x.gradeId == repeatedGrade.grade.id && x.id != 0
          );
          self.gradeDDError =
            existingGrade != null ? self.resources.R900005 : null;
        }

        if (isValid) {
          self.gradeNumberError =
            parseInt(repeatedGrade.quantity, 10) < 1 ||
            repeatedGrade.quantity == ''
              ? self.resources.R900004
              : null;

          if (!self.gradeNumberError && !self.gradeDDError) {
            self.repeatedGradesId += -1;
            repeatedGrade.id = self.repeatedGradesId;
            repeatedGrade.quantity = parseInt(repeatedGrade.quantity, 10);
            repeatedGrade.gradeId = repeatedGrade.grade.id;
            self.showAddRepeatedGradeBtn = true;
          }
        } else {
          self.gradeDDError =
            repeatedGrade.grade == null
              ? self.resources.R900003
              : self.gradeDDError;
          self.gradeNumberError =
            parseInt(repeatedGrade.quantity, 10) < 1 ||
            repeatedGrade.quantity == ''
              ? self.resources.R900004
              : null;
        }
      });
    },
    checkboxGroupValidation(answers, validationName, id) {
      answers.forEach((element) => {
        if ((element.validationName == validationName) & (element.id != id)) {
          element.isSelected = false;
        }
      });
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R900001',
        'R900002',
        'R900003',
        'R900004',
        'R900005',
        '191210',
        'R90007',
        'R90008',
        'R03200110',
        'R03200109',
      ]);
    },
    isValidQuestion(question) {
      if (this.ValidationTriggered.validation) {
        return this.validateQuestionMark(question)
          ? 'custom-control-input'
          : 'custom-control-input checkbox-invalid';
      }
      return 'custom-control-input';
    },
    validateQuestionMark(question) {
      if (!this.ValidationTriggered.validation) {
        return true;
      }

      let answer = question.answers.find((x) => x.isSelected == true);

      if (answer != undefined) {
        return true;
      }
      return false;
    },
    validateRadiobuttons(item) {
      if (item == null && this.ValidationTriggered.validation) {
        return 'El campo es obligatorio';
      }
      return '';
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab3')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
  },
  async mounted() {
    await this.getAcademicInfoOptions();
    await this.getAcademicInfo(this.atServiceId);
    this.fillAcademicInfo();
    this.validateReadMode();
    await this.loadResources();
  },

  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    atServiceId() {
      return store.getters.SelectedAt;
    },
  },
  watch: {
    atServiceId: {
      immediate: true,
      handler(newValue) {
        const btnDisabled = !(newValue > 0);
        this.setATSaveBtnDisable(btnDisabled);
      },
    },
  },
};
</script>

<style scoped>
.checkbox-invalid {
  outline: 2px solid lightcoral !important; /*no funciona*/
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.panel-simple.thead-property .header > div > span {
  font-size: 16px;
}
.gradient {
  background: transparent linear-gradient(180deg, #e4e6e2 0%, #f4f6f300 100%) 0%
    0% no-repeat padding-box;
}
.buttons-container {
  margin-top: 27px;
}
</style>
